var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade","mode":"out-in"}},[(_vm.message)?_c('div',{staticClass:"app-alert",attrs:{"role":"alert"}},[_c('div',[_c('div',{class:("alert alert-" + _vm.type + " mb-0 alert-pop"),staticStyle:{"cursor":"pointer"},attrs:{"title":"Click to dismiss"},on:{"click":_vm.dismiss}},[_vm._v(_vm._s(_vm.message))])])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7e87caa6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppAlert.vue
// module id = 762
// module chunks = 30